import React from "react";
import "./ToggleSwitch.scss";

type Props = {
  label: string;
  isChecked: boolean;
  onToggle: () => void;
  name: string;
};

const ToggleSwitch: React.FC<Props> = ({
  label,
  isChecked,
  onToggle,
  name,
}) => {
  return (
    <div className="toggle-switch">
      <span className="toggle-switch__label">{label}</span>
      <label className="toggle-switch__switch">
        <input
          name={name}
          type="checkbox"
          checked={isChecked}
          onChange={onToggle}
        />
        <span className="toggle-switch__slider"></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
